<p-accordionTab (selectedChange)="togglePanel($event)">
	<ng-template pTemplate="header">
		<div class="flex align-items-center justify-content-between w-full -my-3">
			<div class="font-semibold">{{ 'LIST_TIMERS' | translate }}</div>
			<p-button *ngIf="online" pTooltip="{{ 'RELOAD' | translate }}" tooltipPosition="bottom" icon="pi cm-reload"
				size="large" (click)="$event.stopPropagation(); loadTimers()" [rounded]="false" [text]="true"
				severity="primary">
			</p-button>
		</div>
	</ng-template>
	<div>
		<div *ngIf="passwordSupport && !passwordVerify && online && (isTechnician || isImpersMode)">
			<div class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('PASSWORD_REQUEST_OR_ERR_CON' | translate)" severity="danger"></p-tag>
			</div>
		</div>
		<div *ngIf="loading && online">
			<div class="flex align-items-center justify-content-center w-full">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<div class="grid" *ngIf="!online">
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('OFFLINE_ALERT' | translate)" severity="warning"></p-tag>
			</div>
		</div>
		<div class="grid" *ngIf="!loading && online && isAccess()">
			<div class="col-12">
				<p-table #listTimers dataKey="Position" [value]="timers" [paginator]="true" [loading]="loading"
					[rows]="pageSize" [showCurrentPageReport]="true"
					currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
					responsiveLayout="stack">
					<ng-template pTemplate="caption">
						<div class="grid">
							<div [class]="actionLayout('left')">
								<p-button id="addTimer" label="{{ 'ADD_TIMER' | translate }}" (click)="addTimer()"
									[disabled]="memorySize>=maxMemorySize" icon="pi cm-plus" [rounded]="false" [text]="true"
									severity="primary" styleClass="font-bold border-primary">
								</p-button>
							</div>
							<div [class]="actionLayout('center')">
								<div class="flex flex-column justify-content-center gap-2">
									<span class="flex align-items-center justify-content-center">
										<i class="pi cm-memory-storage mr-1"></i>
										{{'MEMORY_USAGE' | translate }}: {{memorySize}} / {{maxMemorySize}}
									</span>
									<p-progressBar [value]="getValueMemory()">
										<ng-template pTemplate="content" let-value>
											<span *ngIf="getValueMemory() > 4">{{getValueMemory()}} %</span>
										</ng-template>
									</p-progressBar>
								</div>
							</div>
							<div [class]="actionLayout('right')">
								<p-button label="{{ 'REMOVE_ALL' | translate }}" (click)="removeAll()" icon="pi cm-trash"
									[rounded]="false" [text]="true" severity="danger" styleClass="font-bold">
								</p-button>
							</div>
						</div>
					</ng-template>
					<ng-template pTemplate="header">
						<tr>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'DAY_ENABLED' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'START_TIME' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'END_TIME' | translate }}
								</div>
							</th>
							<th>
								<div class="flex align-items-center justify-content-center">
									{{ 'FUNCTION' | translate }}
								</div>
							</th>
							<th>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-timer>
						<tr>
							<td>
								<span class="p-column-title font-semibold">{{ 'DAY_ENABLED' | translate }}</span>
								{{getDays(timer)}}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'START_TIME' | translate }}</span>
								{{getTimeStart(timer)}}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'END_TIME' | translate }}</span>
								{{getTimeEnd(timer)}}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'FUNCTION' | translate }}</span>
								{{getFunction(timer)}}
							</td>
							<td>
								<span class="p-column-title font-semibold">
								</span>
								<div class="flex flex-row justify-content-center align-items-center gap-1">
									<p-button pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom" icon="pi cm-pencil"
										size="large" [rounded]="false" [text]="true" severity="secondary"
										(click)="editTimer(timer)">
									</p-button>
									<p-button pTooltip="{{ 'DELETE' | translate }}" tooltipPosition="bottom" icon="pi cm-trash"
										size="large" [rounded]="false" [text]="true" severity="danger"
										(click)="deleteTimer(timer)">
									</p-button>
								</div>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>
</p-accordionTab>



<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>